// extracted by mini-css-extract-plugin
module.exports = {"bg":"buttonLike_bg__gZ4_M","heart":"buttonLike_heart__3oQA0","liked":"buttonLike_liked__MCYCU","burst":"buttonLike_burst__JYqSy"};